import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import {
    TicketingSystemMerchantList,
    TicketingSystemProvider
} from "ui/organizms/Merchants/TicketingSystem";

const TicketingSystemMerchantListScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Merchants | Ticketing System'
    >
        <TicketingSystemProvider>
            <TicketingSystemMerchantList />
        </TicketingSystemProvider>
    </Screen>
);

export default memo(TicketingSystemMerchantListScreen);
